
import { createClient } from '@supabase/supabase-js';

// NOTE: In a real production app, these should be in a .env file.
const SUPABASE_URL = process.env.SUPABASE_URL || 'https://gwjpiheqdxeiemjwvjdh.supabase.co';
const SUPABASE_ANON_KEY = process.env.SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imd3anBpaGVxZHhlaWVtand2amRoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njc3NTIyMTYsImV4cCI6MjA4MzMyODIxNn0.H-UMKLMdk5lk8zYxIsCH2dZ1sDtey3uU8IlwYru81xE';

// Check if the URL is a valid HTTP/HTTPS URL to prevent crashing
const isValidUrl = (url: string) => {
  try {
    return url && url.startsWith('http');
  } catch (e) {
    return false;
  }
};

if (!isValidUrl(SUPABASE_URL)) {
  console.warn("Supabase URL is missing or invalid. Falling back to mock mode.");
} else {
  console.log(`Supabase client initialized with URL: ${SUPABASE_URL.substring(0, 15)}...`);
}

// Only export the client if the URL is valid. Otherwise export null.
export const supabase = isValidUrl(SUPABASE_URL)
  ? createClient(SUPABASE_URL, SUPABASE_ANON_KEY)
  : null;
